import { useMutation, useQueryClient } from "react-query"
import { InfiniteState } from "../../hooks/types"
import { QUERY_KEY_LISTS } from "./keys"
import { ShowCustomArticleListsResponse } from "../models"
import { sortCustomArticleList } from "../sortCustomArticleList"

export function useSortCustomArticleList() {
    const queryClient = useQueryClient()

    return useMutation(sortCustomArticleList, {
        onMutate: (request) => {
            const previousCompilations = queryClient.getQueriesData<InfiniteState<ShowCustomArticleListsResponse>>({
                queryKey: [QUERY_KEY_LISTS],
            })
            queryClient.setQueriesData<InfiniteState<ShowCustomArticleListsResponse>>(QUERY_KEY_LISTS, (prev) => {
                const compilations = prev?.pages.flatMap((x) => x.data.customArticleLists) ?? []
                const itemToMove = compilations.find((x) => x.id === request.fromId)
                if (!itemToMove) {
                    return prev ?? { pages: [] }
                }
                const fromIndex = compilations.indexOf(itemToMove)
                const newState = {
                    ...prev,
                    pages:
                        prev?.pages.map((page) => {
                            let currentPage = page
                            if (!itemToMove) {
                                return page
                            }
                            if (currentPage.data.customArticleLists.includes(itemToMove)) {
                                currentPage = {
                                    ...currentPage,
                                    data: {
                                        ...currentPage.data,
                                        customArticleLists: currentPage.data.customArticleLists.filter((x) => x !== itemToMove),
                                    },
                                }
                            }
                            let toIndex = currentPage.data.customArticleLists.findIndex((x) => x.id === request.toId)
                            if (fromIndex <= toIndex) {
                                toIndex += 1
                            }
                            if (toIndex !== -1) {
                                currentPage = {
                                    ...currentPage,
                                    data: {
                                        ...currentPage.data,
                                        customArticleLists: [
                                            ...currentPage.data.customArticleLists.slice(0, toIndex),
                                            itemToMove,
                                            ...currentPage.data.customArticleLists.splice(toIndex),
                                        ],
                                    },
                                }
                            }
                            return currentPage
                        }) ?? [],
                }
                return newState
            })

            return { previousCompilations }
        },
        onError: (_err, _vars, context) => {
            context?.previousCompilations.forEach((entry) => queryClient.setQueryData(...entry))
        },
    })
}
